<template>

 <v-layout column align-center justify-start class="mt-5">
                <!-- generation wizard-->

<v-stepper v-model="e1" class="transparent elevation-0 grey lighten-4">
    <v-stepper-header class="elevation-0">
      <v-stepper-step :complete="e1 > 1" step="1" color="primary lighten-1">Script</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 2" step="2" color="primary">Character</v-stepper-step>

      <v-divider></v-divider>

      <v-stepper-step :complete="e1 > 3" step="3" color="primary">Done!</v-stepper-step>

    </v-stepper-header>


    <v-stepper-items class="grey lighten-4" style="padding:10px;padding-top:0px">
      <v-stepper-content step="1" class="white shadow round--border-8">

        <v-card class="mb-5" color="white elevation-0" height="320px" width="500px">
            <div class="heading mt-3 blue lighten-5 pt-2 pb-2 pl-2 round--border-4">
                <!-- <v-icon class="green--text" size="18px">keyboard_arrow_right</v-icon> -->
                Select language of your text script</div>
            <v-select label="Language" data-vv-name="select" required class="ml-2" :items="languages"></v-select>

            <div class="heading mt-4 mb-4 blue lighten-5 pt-2 pb-2 pl-2 round--border-4">
                <!-- <v-icon class="black--text" size="18px">keyboard_arrow_right</v-icon> -->
                Enter text script</div>

            <v-textarea name="input-7-1" outline hint="1000 characters allowed"></v-textarea>

        </v-card>

        <v-btn color="green" class="white--text" @click="e1 = 2">
          Next
        </v-btn>

      </v-stepper-content>

      <v-stepper-content step="2" class="white shadow">
        <v-card class="mb-5 elevation-0" color="white" height="320px" width="500px">
            <div class="heading mt-3 blue lighten-5 pt-2 pb-2 pl-2 round--border-4">
                Choose voice type</div>
            <v-select label="Voice" data-vv-name="select" required class="ml-2" :items="voices"></v-select>

            <div class="heading mt-4 mb-2 blue lighten-5 pt-2 pb-2 pl-2 round--border-4">
                Select character</div>

                <v-avatar>
                    <img src="https://cdn.vuetifyjs.com/images/lists/1.jpg" alt="John">
                </v-avatar>
                <v-avatar>
                    <img src="https://cdn.vuetifyjs.com/images/lists/2.jpg" alt="Tosho">
                </v-avatar>

                <div class="heading mt-4 blue lighten-5 pt-2 pb-2 pl-2 round--border-4">
                Voice Enhancements</div>
                <!-- <v-checkbox :label="`Excited`" class="ml-1" flat></v-checkbox> -->

                <v-layout row wrap>
                    <v-flex xs3>
                        <v-switch label="Excited" color="green" hide-details></v-switch>
                    </v-flex>
                    <v-flex xs3>
                        <v-switch label="Depressed" color="green" hide-details></v-switch>

                    </v-flex>

                </v-layout>
        </v-card>

        <v-btn color="green" class="white--text" @click="e1 = 3">
          Next
        </v-btn>

        <v-btn flat class="grey--text text--darken-1" @click="e1 = 1">
          Back
        </v-btn>
      </v-stepper-content>

      <v-stepper-content step="3" class="white shadow">
        <v-card class="mb-5 elevation-0" color="white" height="320px" width="500px">

            <div class="heading mt-3 blue lighten-5 pt-2 pb-2 pl-2 round--border-4">
                <!-- <v-icon class="green--text" size="18px">keyboard_arrow_right</v-icon> -->
                Select video format</div>
            <v-select label="Video Format" data-vv-name="select" required class="ml-2" :items="formats"></v-select>

        </v-card>

        <v-btn color="green" class="white--text">
          Create Audio
        </v-btn>

        <v-btn color="info" class="white--text">
          Save Configuration
        </v-btn>

        <v-btn flat class="grey--text text--darken-1" @click="e1 = 2">
          Back
        </v-btn>

      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>


                </v-layout>

</template>

<style scoped>
.elevation-0 {
	box-shadow:none !important;
}

.shadow {
	box-shadow: 0px 1px 6px 0px #cec6c6;
}

.round--border-8 {
	border-radius: 8px !important;
}
</style>

<script>
import {Auth} from './auth/cognito_auth';

  export default {
    name: 'lingo_audio_generator',
    data () {
      return {
        e1: 0,
        languages: ['English', 'French', 'German'],
        voices: ['Male', 'Female', 'Kid'],
        formats: ['MP4', 'AVI', 'FLV']
      }
    },
    created () {
      if (! Auth.isUserLoggedIn()) {
        this.$router.push({path: '/'});
        Auth.login(); // how to redirect to this page after login?
      }
    },
    components: {
    }
  }
</script>
